module.exports = __webpack_public_path__ + "img/usa&uk.5837b62e.png";